module.exports = __webpack_public_path__ + "img/image9.16f5ac95.jpg";